export default __webpack_public_path__ + "e2bae196e913f4e4eac70d78a6fb36cd.png";